// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralDocumentService = {};
// console.log("🚀 ~ CollateralDocumentService:", CollateralDocumentService);

CollateralDocumentService.postCollateralDocument = function (data) {
  return lossClient({
    url: "/CollateralDocument/add",
    method: "post",
    data: data,
  });
};

CollateralDocumentService.getCollateralDocumentList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
   
  return lossClient({
    url:
      "/CollateralDocument/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralDocumentService.getCollateralDocumentApprovalList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/CollateralDocument/ApprovalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralDocumentService.putCollateralDocumentApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag == "approve"
      ? { UserId: data.userId, Note: data.note }
      : { UserId: data.userId, Note: data.note };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  

  return lossClient({
    url: `/CollateralDocument/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

CollateralDocumentService.putCollateralDocumentRequest = function (data) {
 

  var bodyRequest = {
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
 
  return lossClient({
    url: `/CollateralDocument/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.CollateralDocumentId,
    },
    data: bodyRequest,
  });
};

CollateralDocumentService.getCollateralDocumentDetail = function (data) {
  return lossClient({
    url: `/CollateralDocument/${data.id}`,
    method: "get",
  });
};

CollateralDocumentService.updateCollateralDocument = function (data) {
 
  const { CollateralDocumentId, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/CollateralDocument/edit",
    method: "put",
    headers: {
      "x-requestId": data.CollateralDocumentId,
    },
    data: requestBody,
  });
};

CollateralDocumentService.deleteCollateralDocument = function (data) {
 
  const { CollateralDocumentId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/CollateralDocument/delete",
    method: "delete",
    headers: {
      "x-requestId": data.CollateralDocumentId,
    },
    data: requestBody,
  });
};

export default CollateralDocumentService;
